Object.defineProperty(exports, "__esModule", { value: true });
exports.HeadingMap = exports.H6 = exports.H5 = exports.H4 = exports.H3 = exports.H2 = exports.H1 = exports.Heading = void 0;
const core_1 = require("@emotion/core");
const styled_system_1 = require("@wheelroom/styled-system");
const merge_ncss_1 = require("../lib/merge-ncss");
const element_1 = require("./element");
const heading_reset_1 = require("./heading-reset");
const getReset = (props) => {
    let reset = { ncss: {} };
    const is = props.is || 'h1';
    if (Object.keys(heading_reset_1.headingResets).includes(is)) {
        reset = merge_ncss_1.mergeNcss([
            heading_reset_1.headingResets[is],
            props.wheel.elementNcss[is],
        ]);
    }
    return reset;
};
exports.Heading = (props) => {
    const label = { ncss: { label: 'heading' } };
    const reset = getReset(props);
    const attrs = element_1.getElementAttrs(props);
    attrs.css = styled_system_1.styledSystem(props.wheel.wrSystemConfig, props.wheel.wrSystemTheme, merge_ncss_1.mergeNcss([label, reset, props.wheel.style, props]));
    return core_1.jsx(props.is || 'h1', attrs, props.children);
};
exports.H1 = (props) => (core_1.jsx(exports.Heading, { is: "h1", wheel: props.wheel }, props.children));
exports.H2 = (props) => (core_1.jsx(exports.Heading, { is: "h2", wheel: props.wheel }, props.children));
exports.H3 = (props) => (core_1.jsx(exports.Heading, { is: "h3", wheel: props.wheel }, props.children));
exports.H4 = (props) => (core_1.jsx(exports.Heading, { is: "h4", wheel: props.wheel }, props.children));
exports.H5 = (props) => (core_1.jsx(exports.Heading, { is: "h5", wheel: props.wheel }, props.children));
exports.H6 = (props) => (core_1.jsx(exports.Heading, { is: "h6", wheel: props.wheel }, props.children));
exports.HeadingMap = {
    h1: exports.H1,
    h2: exports.H2,
    h3: exports.H3,
    h4: exports.H4,
    h5: exports.H5,
    h6: exports.H6,
};
//# sourceMappingURL=heading.js.map